module.exports = __webpack_public_path__ + "static/media/createrole.1e29b4f1.svg";